export const TITULO_MODAL_ESCOLHER_DATA_COBRANCA = 'Trocar data de cobrança'

export const DESCRICAO_MODAL_ESCOLHER_DATA_COBRANCA = 'Escolha abaixo em qual data será feita a cobrança das suas caixinhas a partir do próximo mês:'
